__turbopack_context__.v({
  "kpi_content": "SingleKPI-module-scss-module__e1pLUW__kpi_content",
  "kpi_label": "SingleKPI-module-scss-module__e1pLUW__kpi_label",
  "kpi_metric": "SingleKPI-module-scss-module__e1pLUW__kpi_metric",
  "single_kpi_container": "SingleKPI-module-scss-module__e1pLUW__single_kpi_container",
});
